var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 149,
    height: 149,
    rx: 19.5,
    stroke: "#214ba5",
    strokeDasharray: "6 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7516 71.0316L65.2671 72.4714L73.4252 64.7314L73.4252 84.3059H75.5748L75.5748 64.7314L83.7329 72.4714L85.2484 71.0316L74.5 60.8206L63.7516 71.0316Z",
    fill: "#214ba5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2484 83.2848V87.3692H63.7516V83.2848H61.6019V87.3692C61.6019 87.9108 61.8284 88.4302 62.2315 88.8132C62.6347 89.1962 63.1815 89.4114 63.7516 89.4114H85.2484C85.8185 89.4114 86.3653 89.1962 86.7685 88.8132C87.1716 88.4302 87.3981 87.9108 87.3981 87.3692V83.2848H85.2484Z",
    fill: "#214ba5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8878 71.0316L74.5 60L86.1122 71.0316L83.7332 73.2917L76.1768 66.1226L76.1768 84.8945H72.8232L72.8232 66.1226L65.2668 73.2917L62.8878 71.0316ZM73.4252 64.7314L73.4252 84.3059H75.5748L75.5748 64.7314L83.7329 72.4714L85.2484 71.0316L74.5 60.8206L63.7516 71.0316L65.2671 72.4714L73.4252 64.7314ZM84.6465 82.6962H88V87.3692C88 88.0725 87.7057 88.7435 87.1879 89.2354C86.6706 89.7268 85.9726 90 85.2484 90H63.7516C63.0274 90 62.3294 89.7268 61.8121 89.2354C61.2943 88.7435 61 88.0725 61 87.3692V82.6962H64.3535V86.7805H84.6465V82.6962ZM85.2484 83.2848H87.3981V87.3692C87.3981 87.9108 87.1716 88.4302 86.7685 88.8132C86.3653 89.1962 85.8185 89.4114 85.2484 89.4114H63.7516C63.1815 89.4114 62.6347 89.1962 62.2315 88.8132C61.8284 88.4302 61.6019 87.9108 61.6019 87.3692V83.2848H63.7516V87.3692H85.2484V83.2848Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLg);
export default __webpack_public_path__ + "static/media/upload-lg.39ff0cd153996831e7b4528fe990733a.svg";
export { ForwardRef as ReactComponent };